
import { Link } from 'react-router-dom';
import './styles.scss';
import React, { useState, useEffect } from 'react';

const Announcement = ({ announcement }) => {

    return (
        <>
            {announcement?.link ?

                <div className={`announcement gradient-animation`}>
                    <Link to={announcement.link}>
                        <div className='html-text' dangerouslySetInnerHTML={{ __html: announcement?.content }} />
                    </Link>
                </div>

                :
                <div className={`announcement gradient-animation`}>
                    <div className='html-text' dangerouslySetInnerHTML={{ __html: announcement?.content }} />
                </div>
            }
        </>
    )
}

export default Announcement;